module.exports = __webpack_public_path__ + "img/f33fb03.png";